import axios from 'axios';

// Pobranie API_URL z env lub ustawienie domyślnego
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const instance = axios.create({
    baseURL: API_BASE_URL, // Dynamicznie ustawiana baza URL
});

// Request Interceptor: Dodanie JWT tokena tylko do odpowiednich żądań
instance.interceptors.request.use(
    (config) => {
        // Wykluczamy endpointy logowania, rejestracji trenera, tworzenia szkoły oraz dodawania godzin otwarcia
        const excludedEndpoints = [
            '/api/v1/auth/login',
            '/api/v1/auth/register/trainer',
            '/api/v1/auth/register/owner',
            '/api/v1/auth/registerToExistingSchool/trainer',
            '/api/v1/auth/confirm',
            '/api/v1/auth/reset-password',
            '/api/v1/auth/reset-password-request',
            '/api/v1/school/create', // obejmuje np. /api/v1/school/create/{trainerId}
            '/opening-hours'         // obejmuje np. /api/v1/school/{schoolId}/opening-hours
        ];

        if (!excludedEndpoints.some((endpoint) => config.url.includes(endpoint))) {
            const token = localStorage.getItem('jwt');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error.response &&
            error.response.status === 401 &&
            error.response.data?.message === "JWT token is expired"
        ) {
            console.warn("Sesja wygasła. Przekierowanie...");

            // 💾 Zapisujemy wiadomość do localStorage
            localStorage.setItem("sessionExpiredMessage", "Twoja sesja wygasła, zaloguj się ponownie.");

            // 🗑️ Usuń token
            localStorage.removeItem("jwt");

            // 🔄 Przekierowanie na stronę główną
            window.location.href = "/";
        }
        return Promise.reject(error);
    }
);


export default instance;
